import React from "react";
import { Form, Input, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const DeepLinkField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="DeepLink"
      label={
        <span>
          {t("NOTIFICATION_DEEP_LINK_URL_FIELD")}&nbsp;
          <Tooltip title="Aquest camp conté l'enllaç a la fitxa concreta des de la notificació. És un camp no obligatori que es genera automàticament al seleccionar un asset. De lo contrari s’haurá d’afegir manualment">
            <Icon type="question-circle" />
          </Tooltip>
        </span>
      }
      key="DeepLink"
      initialValue={notification?.Deeplink || ""}
    >
      <Input placeholder={t("NOTIFICATION_DEEP_LINK_URL_INPUT_FIELD")} />
    </Form.Item>
  );
};
